import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TrustRowProps {
  dark?: boolean;
}
export function TrustRow({
  dark = false
}: TrustRowProps) {
  return <div className={`flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-[11px] sm:text-xs font-semibold text-center ${dark ? 'text-cream/90' : 'text-ink'}`} data-id="element-150" data-mp="22xqp6ek7gxby">
      <span className="flex items-center gap-1.5" data-id="element-151" data-mp="2crh9r8d7onmd">
        <span className="text-gold tracking-tighter" aria-hidden="true" data-id="element-152" data-mp="1p0v4tpyi7jgl">
          ⭐⭐⭐⭐⭐
        </span>
        <span data-id="element-153" data-mp="1k1s9ix8bsrlt">4,9/5 — Avis vérifiés de professionnels du fitness senior</span>
      </span>
      <span className="flex items-center gap-1.5" data-id="element-154" data-mp="1yy9hdehb3o3m">
        <ShieldCheckIcon className="w-4 h-4 text-sage shrink-0" data-id="element-155" data-mp="1yvn1mrk9i2ab" />
        <span data-id="element-156" data-mp="1ty3l1l03ddf7">Garantie satisfait ou remboursé 7 jours — Zéro risque</span>
      </span>
    </div>;
}